/**
 * Generates a CSS linear-gradient that renders N evenly-distributed white
 * vertical column bars separated by transparent gaps.
 *
 * Using a CSS gradient (rather than DOM elements) keeps the bars in the
 * background layer — identical behaviour to the original SVG backgroundImage
 * approach, with no z-index or stacking-context side-effects.
 */
export const columnGradient = (count: 4 | 6 | 8, gapPercent = 2.5): string => {
  const barWidth = (100 - (count - 1) * gapPercent) / count;
  const cycleWidth = barWidth + gapPercent;
  const stops: string[] = [];

  for (let i = 0; i < count; i++) {
    const start = parseFloat((i * cycleWidth).toFixed(4));
    const end = parseFloat((start + barWidth).toFixed(4));
    stops.push(`white ${start}%`, `white ${end}%`);
    if (i < count - 1) {
      const gapEnd = parseFloat((end + gapPercent).toFixed(4));
      stops.push(`transparent ${end}%`, `transparent ${gapEnd}%`);
    }
  }

  return `linear-gradient(90deg, ${stops.join(', ')})`;
};
